export const PADDING_LARGE = 'large';
export const PADDING_SMALL = 'small';
export const PADDING_NO_PADDING = 'noPadding';

export const GAP_SMALL = 'small';
export const GAP_LARGE = 'large';

export const COLOR_WHITE = 'white';
export const COLOR_WHITE_AND_RED = 'whiteAndRed';
export const COLOR_BLACK = 'black';
export const COLOR_RED = 'red';
export const COLOR_YELLOW_AND_BLACK = 'yellow';
export const COLOR_RED_AND_WHITE = 'redAndWhite';
